/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';
import {
  FormDialog,
  FormDialogActions,
  FormDialogContent,
  FormDialogTitle,
  FormInputsStack,
  FormSubmissionError,
  FormCancelButton,
  useForm,
  getSubmitButtonProps,
  FormElement,
  Inputs,
} from '@marageti/z4-lib';
import { LoadingButton } from '@mui/lab';
import { zodResolver } from '@hookform/resolvers/zod';
import * as z from 'zod';
import { ViewProps } from './types';

const schema = z.object({
  capacity: z.number({
    invalid_type_error: 'Please enter a capacity',
  }).min(0, 'Value must be greater than or equal to 0').max(1000, 'Value must be less than or equal to 1000'),
});

const EditCapacityView = ({
  open,
  onCancel,
  onSubmit,
  submissionError,
  partner,
}: ViewProps) => {
  const {
    handleSubmit,
    formState: { errors, isSubmitting, isValid },
    reset,
    register,
  } = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      capacity: partner?.capacity,
    },
  });

  useEffect(() => {
    reset({
      capacity: partner?.capacity,
    });
  }, [partner?.capacity]);

  const handleClose = () => {
    reset();
    onCancel();
  };

  return (
    <FormDialog
      open={open}
    >
      <FormDialogTitle handleClose={handleClose}>
        Max Capacity
      </FormDialogTitle>
      <FormElement name="profile-editor-form" onSubmit={handleSubmit(onSubmit)}>
        <FormDialogContent>
          <FormInputsStack>
            {submissionError
                && (
                <FormSubmissionError
                  message={submissionError.message}
                  errorCode={submissionError.code}
                  errorId={submissionError.id}
                />
                )}
            <Inputs.Number
              error={!!errors?.capacity}
              helperText={errors?.capacity?.message as string}
              id="capacity"
              label="Leads Per Week"
              {...register('capacity', { valueAsNumber: true })}
            />
          </FormInputsStack>
        </FormDialogContent>
        <FormDialogActions>
          <FormCancelButton onClick={onCancel} />
          <LoadingButton type="submit" variant="contained" {...getSubmitButtonProps(isSubmitting, isValid)}>Submit</LoadingButton>
        </FormDialogActions>
      </FormElement>
    </FormDialog>
  );
};

export default EditCapacityView;
